// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Receita_CardsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/receita/cards
 *
 * Hero cash KPIs for the Receita tab, scoped by the user's session filter
 * (franquias + period). All monetary values are in centavos (int) to match
 * `contas_recebimentos.recebimento_valor*` storage.
 *
 * - recebido_bruto:        SUM(recebimento_valor)         — gross
 * - recebido_liquido:      SUM(recebimento_valor_liquido) — net of taxas
 * - total_taxas:           SUM(recebimento_valor_taxas)
 * - total_antecipacoes:    SUM(recebimento_valor - recebimento_valor_liquido) when provedor != 'manual'
 *                          minus total_taxas (anticipation fees vs processing taxas)
 * - total_deductions:      total_taxas + total_antecipacoes (combined deduction headline)
 * - count_recebimentos:    number of recebimento rows in the period
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Receita_CardsResponseDados {
recebido_bruto: number
recebido_liquido: number
total_taxas: number
total_antecipacoes: number
total_deductions: number
count_recebimentos: number
}

export type Receita_CardsResponse = ApiResponse<Receita_CardsResponseDados>;

registerResponseContract('Receita_CardsResponse', {
  recebido_bruto:     { type: 'number',  required: true },
  recebido_liquido:   { type: 'number',  required: true },
  total_taxas:        { type: 'number',  required: true },
  total_antecipacoes: { type: 'number',  required: true },
  total_deductions:   { type: 'number',  required: true },
  count_recebimentos: { type: 'number',  required: true },
})
